import { Row } from "@/common/custom-lists/ListView";
import { getNumberWithOrdinal } from "@/common/validation/Validators";
import Tooltip from "@/tooltip";
import { BoltIcon, BuildingOffice2Icon, CurrencyEuroIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import InfoCard from "@/components/common/cards/InfoCard";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Actions as AUTHENTICATION_ACTIONS } from "@/redux/actions/authenticationActions";
import { CurrencyIcon } from "@/components/common/icons/CurrencyIcons";

import { differenceInCalendarDays, format as formatDate, parse } from "date-fns";
const format = (date, format) => {
	try {
		return formatDate(date, format)
	} catch (error) {
		return "Unknown"
	}
};

function GoToPayroll({ onClick, view, jurisdiction, style }) {
	return (
		<button
			className={`btn btn-xs btn-primary`}
			style={{ display: "block", width: "fit-content", ...style }}
			type="button"
			onClick={onClick}
		>
			<Tooltip
				content={"Go to Payroll"}
				arrowSize={4}
			>
				<CurrencyIcon
					jurisdiction={jurisdiction}
					className="h-5 w-5 text-dark-gray"
					style={view === "Card" ? { verticalAlign: "middle", marginRight: 2 } : { verticalAlign: "middle" }}
				/>
				{view === "Card" ? "Go to Payroll" : null}
			</Tooltip>
		</button>
	);
}

function SwitchCompany({ onClick, view }) {
	return (
		<Tooltip
			className="btn btn-xs btn-default"
			style={{ textWrap: "nowrap" }}
			type="button"
			onClick={onClick}
			content={"Switch Company"}
		>
			<BuildingOffice2Icon
				className="h-5 w-5 text-dark-gray"
				style={view === "Card" ? { verticalAlign: "middle", marginRight: 2 } : { verticalAlign: "middle" }}
			/>
			{view === "Card" ? "Switch Company" : null}
		</Tooltip>
	);
}

function EverRoll({ onClick, view, automated, company }) {
	return (
		<Link
			to={`/advisor/ever-roll?company=${company}`}
			style={{
				fontWeight: "bolder",
				borderRadius: "1rem",
				textWrap: "nowrap",
				border: "1px solid",
				borderColor: automated ? "#ea611c" : "gray",
				color: "black",
				padding: view === "Card" ? "0.125rem 0.5rem 0.375rem 0.5rem" : "0rem 0.5rem",
				marginLeft: "0.5rem",
			}}
			onClick={onClick}
		>
			<span>
				<BoltIcon
					style={{
						verticalAlign: "middle",
						marginLeft: "0.5rem",
						height: "2rem",
						color: automated ? "#ea611c" : "gray",
					}}
				/>
				EverRoll™
			</span>
		</Link>
	);
}
const ScheduledPayrollRow = ({ period, view, switchCompany }) => {
	const {
		payScheduleName,
		periodStart,
		periodEnd,
		paySchedule: periodSchedule,
		payPeriods,
		year,
		companyName,
		status,
		org,
		jurisdiction,
		payDay,
		automated,
		period: periodNo,
	} = period || {};
	const periodOrdinal = getNumberWithOrdinal(periodNo);
	const periodDuration =
		periodStart && periodEnd
			? `${format(new Date(periodStart), "do MMM")} - ${format(new Date(periodEnd), "do MMM")}`
			: "Unknown";

	const to = `/organisation/payroll/${period?.id}`;

	const differenceToDueDate = (() => {
		if (payDay) return differenceInCalendarDays(parse(payDay, "yyyy-MM-dd", new Date()), new Date())
		if (year) return differenceInCalendarDays(new Date(`${year}-01-01`), new Date())
		return 0;
	})();
	const isLate = differenceToDueDate < 0;

	if (view === "Card")
		return (
			<InfoCard
				header={
					<div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}>
						<div style={{ display: "flex", gridColumn: "1 / span 2" }}>
							<div
								className={`item item-circle bg-primary`}
								style={{ position: "relative", height: "4rem", width: "4rem", flexShrink: 0 }}
							>
								<CurrencyIcon
									jurisdiction={jurisdiction}
									style={{
										position: "absolute",
										height: "3rem",
										color: "white",
										right: "0.5rem",
										top: "0.5rem",
									}}
								/>
							</div>
							<div style={{ marginLeft: "1rem" }}>
								<h4>{companyName}</h4>
								<h6>
									{periodOrdinal} {payScheduleName ? ` ${payScheduleName}` : null} Payroll
								</h6>
							</div>
						</div>
						<div className="pull-right">
							<EverRoll
								view={view}
								company={org}
								automated={automated}
							/>
						</div>
					</div>
				}
				content={
					<div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }}>
						<div>
							<h6>Due on: {payDay ? format(new Date(payDay), "do MMMM") : "Unknown"}</h6>
							<div
								className="chip"
								style={{
									background: "white",
									border: `1px solid ${isLate ? "red" : "green"}`,
									color: isLate ? "red" : "green",
									marginLeft: "0rem",
									marginRight: "0.5rem",
									display: "inline-block",
								}}
							>
								{Math.abs(differenceToDueDate)}
								{!isLate ? " days until" : " days ago"}
							</div>
						</div>
						<div>
							<div
								className="chip pull-right"
								style={{ background: "#ffdecd", color: "#ea611c", marginLeft: 0 }}
							>
								{periodDuration}
							</div>
							<div className="clearfix" />
							<div className="help-block text-right">of {year}</div>
						</div>
					</div>
				}
				footer={
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<SwitchCompany
							view={view}
							onClick={() => switchCompany(org)}
						/>
						<GoToPayroll
							view={view}
							jurisdiction={jurisdiction}
							onClick={() => switchCompany(org, to)}
							to={to}
						/>
					</div>
				}
			/>
		);

	return (
		<Row
			columns={[
				<>
					<div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
						{isLate ? (
							<div className="btn btn-xs btn-warning">
								<Tooltip content={`${Math.abs(differenceToDueDate)} days late`}>
									<ExclamationTriangleIcon
										className="h-5 w-5 text-dark-gray"
										style={{ verticalAlign: "middle" }}
									/>
								</Tooltip>
							</div>
						) : null}
					</div>
				</>,
				<>
					<div className="text-left">
						<h5>
							<BuildingOffice2Icon
								style={{
									height: "1.725rem",
									float: "left",
									marginRight: 5,
								}}
							/>
							{companyName}
							<div
								className="chip"
								style={{
									background: "white",
									border: "1px solid #ea611c",
									color: "#ea611c",
									marginLeft: "0.5rem",
									marginRight: "0.5rem",
									display: "inline-block",
								}}
							>
								{year}
							</div>
						</h5>
					</div>
				</>,
				<>
					<div>
						<h6>
							{periodOrdinal}, {payScheduleName || "Payroll"}
						</h6>
						<div
							className="chip"
							style={{ background: "#ffdecd", color: "#ea611c", marginLeft: "0rem" }}
						>
							{periodDuration}
						</div>
						{/* <div className="help-block">
							{periodOrdinal} {payScheduleName} Payroll of {year}
						</div> */}
					</div>
				</>,
				<>
					<div>
						<h5>{payDay ? format(new Date(payDay), "do MMMM") : "Unknown"}</h5>
						<p style={{ marginBottom: 0, color: !isLate ? "green" : "red" }}>
							{Math.abs(differenceToDueDate)}
							{!isLate ? " days until" : " days ago"}
						</p>
					</div>
				</>,
				<>
					<div className="badge badge-default">{status || "Open"}</div>
				</>,
				<>
					<div style={{ display: "flex", justifyContent: "start", marginTop: "1rem" }}>
						<GoToPayroll
							jurisdiction={jurisdiction}
							view={view}
							onClick={() => switchCompany(org, to)}
							style={{ marginRight: "0.5rem" }}
							to={to}
						/>
						<SwitchCompany
							view={view}
							onClick={() => switchCompany(org)}
						/>

						<EverRoll
							automated={automated}
							company={org}
						/>
					</div>
				</>,
			]}
		/>
	);
};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	switchCompany: (company, link) => dispatch(AUTHENTICATION_ACTIONS.switchCompany(company, link)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledPayrollRow);
